import React from 'react';
import {Redirect} from 'react-router-dom';
import Loadable from 'components/Loadable';
import {ENABLE_ISO_SURVEY} from 'configs/enable-features';
import {useMembership} from 'contexts/MembershipContext';
import {SUBSCRIPTION_TYPE_LEVEL} from 'configs/membership';

const analytics = {
  path: '/analytics',
  component: Loadable({
    loader: () => import('../views/analytics'),
  }),
  routes: [
    {
      exact: true,
      path: '/analytics',
      component: () => {
        const {subscriptionLevel} = useMembership();
        const isEnterprise =
          subscriptionLevel === SUBSCRIPTION_TYPE_LEVEL['enterprise'];
        const isFree = subscriptionLevel === SUBSCRIPTION_TYPE_LEVEL['free'];

        if (isEnterprise || isFree)
          return <Redirect to="/analytics/iso-survey" />;

        return <Redirect to="/analytics/certifications" />;
      },
    },
    {
      path: '/analytics/certifications',
      component: Loadable({
        loader: () => import('../views/analytics/certifications'),
      }),
    },
    {
      path: '/analytics/sites',
      component: Loadable({
        loader: () => import('../views/analytics/sites'),
      }),
    },
    {
      path: '/analytics/certified-entities',
      component: Loadable({
        loader: () => import('../views/analytics/certified-entities'),
      }),
    },
    {
      path: '/analytics/certification-bodies',
      component: Loadable({
        loader: () => import('../views/analytics/certification-bodies'),
      }),
    },
    {
      path: '/analytics/locations',
      component: Loadable({
        loader: () => import('../views/analytics/locations'),
      }),
    },
    ENABLE_ISO_SURVEY && {
      path: '/analytics/iso-survey',
      component: Loadable({
        loader: () => import('../views/analytics/iso-survey'),
      }),
    },
    {
      path: '/analytics/real-time-analytics',
      component: Loadable({
        loader: () => import('../views/analytics/real-time-analytics'),
      }),
    },
    ENABLE_ISO_SURVEY && {
      path: '/analytics/iso-history',
      component: Loadable({
        loader: () => import('../views/analytics/iso-history'),
      }),
    },
  ].filter(Boolean),
};

export default analytics;
